/**
 * sign-shell — the page a signed-out (or not yet placed) person stands on:
 * the lowest surface and the one centred column the sign-in's steps sit in.
 * The sign-in renders its steps inside it, and the bare host's organization
 * picker stands in the same place, so the two read as one door.
 *
 * `display: contents`: the shell adds no box of its own, so whoever hosts it
 * lays the surface out exactly as if it were their own child.
 */
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { css, html } from "lit";

@schmancyElement("sign-shell")
export class SignShell extends SchmancyElement {
	// A host that seats the shell in its own overlay sets --sign-shell-top on
	// it (or any ancestor); a page keeps the eye line.
	static styles = [
		css`
			:host { display: contents; }
			[part="column"] {
				padding-top: var(--sign-shell-top, var(--spacing-eye));
				padding-bottom: var(--sign-shell-bottom, 4rem);
			}
		`,
	];

	override render() {
		return html`
			<schmancy-surface type="containerLowest" opacity="solid" class="h-full w-full">
				<div part="column" class="mx-auto flex max-w-md w-full flex-col">
					<slot></slot>
				</div>
			</schmancy-surface>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"sign-shell": SignShell;
	}
}
